// extracted by mini-css-extract-plugin
export default {"menu-items":"menu-items-581b"};